export default __webpack_public_path__ + "fonts/83da3e7e4820efe6776716a75f48cd6b.ttf";